export default __webpack_public_path__ + "static/media/Pita-bread.b1f3c82a.jpg";